export default __webpack_public_path__ + "static/media/carrot.e95f0d80.svg";